{
  "about": {
    "meta": {
      "title": "About - MAJORITY",
      "description": "What to know more about MAJORITY? We give migrants the tools, resources, and support to thrive in a new country. Learn more!"
    },
    "our_mission": {
      "hey_there": "HEY THERE!",
      "we_are_majority": "We are MAJORITY. Our mission is to give you the tools, resources, and support to thrive in a new country. We believe that everyone should be valued for their positive impact on the world and not judged by their country of origin."
    },
    "join_us": {
      "title": "Join us",
      "we_are_description": "We are a diverse group of proud migrants from over 40 different countries. We work together to create meaningful products that bridge cultural and geographic distances. If this speaks to you, then we’d love to hear from you.",
      "languages": "Languages",
      "nacionalities": "Nationalities",
      "individuals": "Individuals",
      "see_all_jobs": "See all jobs"
    },
    "career": {
      "meta": {
        "title": "Careers",
        "description": "We are a diverse group of proud migrants from over 40 different countries. We work together to create meaningful products that bridge cultural and geographic distances. Join us!"
      },
      "meta_apply": {
        "description": "Want to work with us? We’d love to hear from you!"
      },
      "hero_title": "Job Openings",
      "hero_description": "Calling all movers and shakers! Let’s make something awesome together.",
      "open_positions": "Open positions",
      "show_jobs_in": "Show jobs in:",
      "job_location_all": "All locations",
      "department": "Department:",
      "location": "Location:",
      "apply_now": "Apply now"
    },
    "press": {
      "title": "Have a media inquiry?",
      "description": "Let's connect! Please email <a class=\"{variant}\" href=\"mailto:{email}\">{email}</a>",
      "button": "Download press kit"
    }
  }
}